jQuery(document).ready(function ($) {
  console.log("heello");
  $("#buttonMe").on("click", function (e) {
    e.preventDefault();
    console.log("tekan tekan");
    $(".carousel-review-image .flickity-prev-next-button.next").css(
      "background-color",
      "#000"
    );
    $(".carousel-review-image .flickity-prev-next-button.next").click();
    document
      .querySelector(".carousel-review-image .flickity-prev-next-button.next")
      .click();
  });
  $(".carousel-review-image .flickity-prev-next-button.next").on(
    "click",
    function () {
      console.log("button next");
      //   $(".carousel-review-content .flickity-prev-next-button.next").click();
      console.log(
        "ada ga?: ",
        $(".carousel-review-content .flickity-prev-next-button.next").length
      );

      $(".carousel-review-content .flickity-prev-next-button.next").click();
      $(".carousel-review-content .flickity-prev-next-button.next").trigger(
        "click"
      );
    }
  );

  $(".carousel-review-image .flickity-prev-next-button.previous").on(
    "click",
    function () {
      console.log("button previous");
      console.log(
        "ada ga?: ",
        $(".carousel-review-content .flickity-prev-next-button.previous").length
      );

      $(".carousel-review-content .flickity-prev-next-button.previous").click();
      $(".carousel-review-content .flickity-prev-next-button.previous").trigger(
        "click"
      );
    }
  );
});

/**
 * Special collection on hover
 */

const triggerCollections = document.querySelectorAll(
  ".trigger-hover-collection"
);
const isCollectionsExist =
  typeof triggerCollections !== "undefined" && triggerCollections !== null;

if (isCollectionsExist) {
  // if item available
  triggerCollections.forEach(function (elItem) {
    elItem.addEventListener("mouseenter", function (item) {
      // add class active on mouseenter
      const bg = item.target.getAttribute("data-background");
      const sectionID = item.target.getAttribute("data-section");
      const elBg = document.getElementById(bg);
      const elSection = document.querySelector(
        "#" + sectionID + " .SpecialCollection__container"
      );

      if (elBg !== null) {
        elBg.classList.add("active");
        elSection.classList.add("is-hover");
      }
    });

    elItem.addEventListener("mouseleave", function (item) {
      // remove class active on mouseleave
      const bg = item.target.getAttribute("data-background");
      const sectionID = item.target.getAttribute("data-section");
      const elBg = document.getElementById(bg);
      const elSection = document.querySelector(
        "#" + sectionID + " .SpecialCollection__container"
      );

      if (elBg !== null) {
        elBg.classList.remove("active");
        elSection.classList.remove("is-hover");
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  //product-tab js
  const tabTitles = document.querySelectorAll(".tab-title");
  const tabItems = document.querySelectorAll(".custom-tab-item");
  const tabImages = document.querySelectorAll(".tab-image");

  function showTab(index) {
    for (let i = 0; i < tabItems.length; i++) {
      tabTitles[i].classList.remove("active");
      tabItems[i].style.display = "none";
      tabImages[i].style.display = "none";
    }

    tabTitles[index].classList.add("active");
    tabItems[index].style.display = "block";
    tabImages[index].style.display = "block";
  }

  showTab(0);

  tabTitles.forEach(function (tabTitle) {
    tabTitle.addEventListener("click", function () {
      const tabIndex = tabTitle.getAttribute("data-tab-index");
      showTab(tabIndex - 1);
    });
  });

  //js for auto open the filter collection template
  var customCollapsibleButtons = document.querySelectorAll(
    ".Collapsible--custom .Collapsible__Button"
  );

  customCollapsibleButtons.forEach(function (button) {
    setTimeout(function () {
      button.setAttribute("aria-expanded", "true");
    }, 100); //
  });
});

/* A8 accessible name for the WhatsApp app bubble (its image has an empty alt) */
(function () {
  function label() {
    document.querySelectorAll('a[href*="api.whatsapp.com"]:not([aria-label])').forEach(function (a) {
      a.setAttribute('aria-label', 'Chat with us on WhatsApp');
    });
  }
  label();
  document.addEventListener('DOMContentLoaded', label);
  window.addEventListener('load', label);
})();
